import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  SessionOption,
  EventOption,
  PrimitiveMapEntity,
} from '../../../core/services/facility-pin.service';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { CameraService } from '../../../core/services/camera.service';
import { DataContextService } from '../../../core/services/data-context.service';
import { CommonModule } from '@angular/common';
import { PinKeypadComponent } from '../common-modal/pin-keypad.component';
import { SettingsService } from '../../../core/services/settings.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseModalComponent } from '../response-modal/response-modal.component';
import { ArcAngelMonitorModeService } from '../arc-angel-monitor-mode.service';
import { ArcAngelLiveModeService } from '../../../core/services/arc-angel-live-mode.service';
import { IncidentCategoryService } from '../../../core/services/incident-category.service';
import { CoreService } from '../../../core/services/core.service';
import { ArcAngelService } from '../../../core/services/arc-angel.service';
import { Subject, takeUntil } from 'rxjs';
import { DeviceService } from '../../../core/services/device.service';
import _ from 'lodash';
import * as Cesium from 'cesium';
import { IllumLiveService } from '../../../core/services/illum-live.service';
import { WindowService } from '../../../core/services/window.service';
import { TimelineService } from '../../../core/services/timeline.service';
const LIVE_MODE = 'Live Mode';
const INCIDENT = 'INCIDENT';

@Component({
  selector: 'app-incident',
  standalone: true,
  imports: [CommonModule, FormsModule, PinKeypadComponent],
  templateUrl: './incident.component.html',
  styleUrl: './incident.component.css',
})
export class IncidentComponent implements OnChanges, OnDestroy {
  @Input() incidentDetails: any[] = [];
  @Output() openPinDialog = new EventEmitter<any>();
  @Input() geofenceResults: any;
  @Input() buildingMapEntity: any;
  ModalId: any;
  showPinDialog: boolean = false;
  options: any; // Add this property to fix the error
  pinDialogData: any = null; // Optionally pass data to the dialog
  showPinModal: boolean = false;
  pinUI: string = '';
  showFormSection: boolean = false;
  @Output() close = new EventEmitter<any>();
  @Input() pinValue: string = '';
  showBuildingCamera: boolean = false;
  private destroy$ = new Subject<void>();
  mode: any;

  sortOptions: string[] = ['Name', 'Created'];
  sortByOption: string = this.sortOptions[0];

  statusOptions: string[] = ['All Statuses', 'Active', 'Pending'];
  statusOption: string = this.statusOptions[0];
  searchQuery: string = ''; 
  constructor(
    private sessionOptionsService: SessionOptionsService,
    private dataContext: DataContextService,
    private camera: CameraService,
    private settingService: SettingsService,
    private modalService: NgbModal,
    private arcAngelMonitorModeService: ArcAngelMonitorModeService,
    private arcAngelLiveModeService: ArcAngelLiveModeService,
    private incidentCategoryService: IncidentCategoryService,
    private coreService: CoreService,
    private arcangelService: ArcAngelService,
    private deviceService: DeviceService,
    private illumLiveService: IllumLiveService,
    private windowService: WindowService,
    private timelineService: TimelineService
  ) {}

  ngOnInit(): void {
    // Subscribe to monitor events changes
    this.arcAngelMonitorModeService.monitorEvents$
      .pipe(takeUntil(this.destroy$))
      .subscribe((events) => {
        this.processEvents(events);
      });
  }

  private processEvents(events: any) {
    this.incidentDetails = this.arcAngelMonitorModeService.data.monitorEvents;
    if (this.incidentDetails && this.incidentDetails.length > 0) {
      this.incidentDetails.map((incident) => {
        // this.device.getCountDevicesByPerimeterAndStatus(+incident.id).pipe(
        //   tap((statusData) => {
        const statusData =
          this.deviceService.data.userStatusByIncidentDict?.[
            incident.eventId
          ] || [];
        if (!statusData || statusData.length === 0) {
          incident.userStatuses = {
            building: { danger: 0, safe: 0, unknown: 0 },
            street: { danger: 0, safe: 0, unknown: 0 },
          };
        }
        // Find building and street data
        const buildingData = _.find(statusData, (o) => {
          return o.type === 'BUILDING';
        });
        //const buildingData = statusData.find((o: any) => o.type === 'BUILDING');
        const streetData = _.find(statusData, (o) => {
          return o.type === 'STREET';
        });

        let buildingUsers = {
          danger: 0,
          safe: 0,
          unknown: 0,
        };

        if (buildingData) {
          buildingUsers = {
            danger: buildingData?.danger ? parseInt(buildingData?.danger) : 0,
            safe: buildingData?.safe ? parseInt(buildingData.safe) : 0,
            unknown: buildingData?.unknown ? parseInt(buildingData.unknown) : 0,
          };
        }

        let streetUsers = {
          danger: 0,
          safe: 0,
          unknown: 0,
        };

        if (streetData) {
          streetUsers = {
            danger: streetData.danger ? parseInt(streetData.danger) : 0,
            safe: streetData.safe ? parseInt(streetData.safe) : 0,
            unknown: streetData.unknown ? parseInt(streetData.unknown) : 0,
          };
        }

        incident.userStatuses = {
          danger: buildingUsers.danger + streetUsers.danger,
          safe: buildingUsers.safe + streetUsers.safe,
          unknown: buildingUsers.unknown + streetUsers.unknown,
        };
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Ensure a map entity exists for each incident
    for (const incident of this.incidentDetails) {
      let mapEntity = this.dataContext.getMapEntity(incident.id);
      if (!mapEntity) {
        mapEntity = new PrimitiveMapEntity(
          incident.name,
          'IncidentsLayer',
          this.camera,
          this.coreService,
          this.windowService,
          this.dataContext,
          this.modalService,
          this.timelineService
        );
        mapEntity.id = incident.id;
        // Set coordinates if available (allow 0 as valid value)
        if (incident.latitude != null)
          mapEntity.setCenterLatitude(incident.latitude);
        if (incident.longitude != null)
          mapEntity.setCenterLongitude(incident.longitude);
        mapEntity.buildEntity();
        this.dataContext.addMapEntity(mapEntity);
      }
    }
  }
  async switchToLiveIncidentMode(
    id: string,
    byPassPin: boolean
  ): Promise<void> {
    if (byPassPin) {
      this.goToLiveIncidentMode(id, true);

      return;
    }
    this.goToLiveIncidentMode(id, true, true);
    const geometries = this.geofenceResults?.rows
      .filter((item: any) => item.incidentId === id)
      .map((item: any) => item.geometry);
    if (geometries?.length > 0) {
      const [longitude, latitude] = geometries[0].coordinates[0][0];
      this.showBuildingCamera = true;
      this.onPinDialogClosed('false');
      this.camera.flyToLocation(latitude, longitude, id);
      return;
    }
  }
  goToLiveIncidentMode(
    incidentId: string,
    byPassPin: boolean,
    suppressReset = false
  ): void {
    const event = new EventOption(incidentId, INCIDENT);
    const sessionOption = new SessionOption(
      LIVE_MODE,
      event,
      byPassPin,
      suppressReset
    );
    this.arcangelService.updatePerimeterSafetyStatus(incidentId, null);
    this.sessionOptionsService.setSessionData(sessionOption);
  }
  goToEntity(entity: any): void {
    if (entity) {
      const [longitude, latitude] = [entity.centerLongitude, entity.centerLatitude];
      	this.camera.flyTo({
					destination: Cesium.Cartesian3.fromDegrees(longitude, latitude, 500),
					complete: function(){
						if(!entity.isBuildingIncident()){
							entity.goToEntity(() => {
								//ArcAngelMonitorModeService.methods.startSceneSwitch();
							});
						}else{
							entity.viewDetailsWindow(entity);
							//ArcAngelMonitorModeService.methods.startSceneSwitch();
						}
					}
				});
    }
  }

  continueButtonClicked(id: any): void {
    // this.openPinDialog.emit(id);
    this.showPinDialog = true;
    this.ModalId = id;
  }
  /// on click on go live incident
  goLiveIncident(item: any , mode: string) {
    this.showPinDialog = true;
    this.ModalId = item.eventId;
    this.mode = mode;
    // ArcAngelModesService.swithToLiveIncidentMode(item.getEventId());
  }

  onPinDialogClosed(result: any) {
    if (typeof document !== 'undefined' && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    this.pinValue = '';
    this.showPinDialog = false;
  }
  private closeDialog(result: string, data?: any) {
    this.close.emit(result);
  }
  cancel() {
    this.closeDialog('cancel');
  }
  async confirmPublicIncident(entity: any) {
    if (this.mode === 'active') {
      this.settingService.verifyPin(this.pinValue).subscribe(
        (response) => {
          if (!response?.validPin) {
            this.showAlert('Invalid PIN');
            return;
          }
          const orgId = this.arcAngelMonitorModeService.getOrgIdForLiveIncident(this.ModalId);
          this.illumLiveService.setManagingOrgId(Array.isArray(orgId) ? orgId[0] : (orgId ?? '0'));
          this.incidentCategoryService.setManagingOrgId(orgId ?? '0');
          this.sessionOptionsService.goToLiveIncidentMode(this.ModalId, true, true);
          this.arcAngelLiveModeService.startLiveIncidentMode(this.ModalId, this);
          this.onPinDialogClosed('false');
        },
        () => {
          this.showAlert('Invalid PIN');
        }
      );
    } else if (this.mode === 'pending') {
      try {
        const response = await this.settingService.verifyPin(this.pinValue).toPromise();
        if (!response?.validPin) {
          this.showAlert('Invalid PIN');
          return;
        }
        this.incidentCategoryService['_verifiedPin'] = this.pinValue;
         const orgId = this.arcAngelMonitorModeService.getOrgIdForLiveIncident(this.ModalId);
          let isCampus = false;
          if (Array.isArray(orgId) && orgId.length > 1) {
            isCampus = true;
          }
          this.illumLiveService.setManagingOrgId(Array.isArray(orgId) ? orgId[0] : (orgId ?? '0'));
          this.incidentCategoryService.setManagingOrgId(orgId ?? '0');
        const eventResponse = await this.incidentCategoryService.updateStatusOfEvent(this.ModalId, 'active', isCampus).toPromise();
        if (eventResponse && eventResponse.status === "ACTIVE") {
          this.sessionOptionsService.goToLiveIncidentMode(this.ModalId, true, true);
          this.arcAngelLiveModeService.startLiveIncidentMode(this.ModalId, this);
          this.onPinDialogClosed('false');
        } else {
          this.showAlert('Failed to activate incident.');
        }
      } catch (error) {
        this.showAlert('Error activating incident.');
      }
    }
  }

  get filteredIncidents() {
    let list = [...this.incidentDetails];
    
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      list = list.filter(item => (item.name || '').toLowerCase().includes(query));
    }
    
    if (this.statusOption !== 'All Statuses') {
      list = list.filter(item => (item.status || '').toLowerCase() === this.statusOption.toLowerCase());
    }

    if (this.sortByOption === 'Name') {
      list.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    } else if (this.sortByOption === 'Created') {
      list.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    }

    return list;
  }

  onSortOptionClicked(option: string) {
    this.sortByOption = option;
  }

  onStatusOptionClicked(option: string) {
    this.statusOption = option;
  }

  private showAlert(message: string) {
    const modalRef = this.modalService.open(ResponseModalComponent, {
      centered: true,
      windowClass: 'response-modal-top zindex',
      backdropClass: 'response-modal-backdrop-top',
    });
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.showCancel = false;
    return modalRef.result;
  }
  closeIncident(item: any) {
    this.incidentCategoryService.setManagingOrgId(item.orgid);

    if (!item.isClosed()) {
      const modalRef = this.modalService.open(ResponseModalComponent, {
        centered: true,
        windowClass: 'response-modal-top zindex',
        backdropClass: 'response-modal-backdrop-top',
      });
      modalRef.componentInstance.message = 'Are you sure you want to close this pending incident?';
      modalRef.componentInstance.showCancel = true;

      modalRef.result.then((confirmed: boolean) => {
        if (confirmed) {
          item.setClosed();
          this.incidentCategoryService.updateStatusOfEvent(item.eventId, 'inactive').subscribe();
        }
      }).catch(() => {});
    }
  }
}